import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { I18nModule } from '../../../../core/i18n';
import { Unit, VolumeDiscount } from '../../../../core/model';
import { PipesModule } from '../../../pipes';

@Component({
  selector: 'py-volume-discount-table',
  templateUrl: './volume-discount-table.component.html',
  styleUrls: ['./volume-discount-table.component.scss'],
  imports: [CommonModule, PipesModule, I18nModule, NzIconModule],
})
export class VolumeDiscountTableComponent {
  @Input() volumeDiscount: VolumeDiscount;
  @Input() quantity: number;
  @Input() unit: Unit;

  formatNegativePrice(price?: string): string {
    return price?.replace(/^[^\d\s]*\d|\d/, '-$&');
  }
}
